import React, { useState, useEffect } from "react";
import styled from "styled-components";
import BraftEditor from "braft-editor";
import { Content, Header } from "antd/es/layout/layout";
import { Layout, message, Button } from "antd";
import { uploadImages, addAboutUsInfo, getManagerAboutUsInfo, editAboutUsInfo } from '../../http/manager';
import { showFullScreenLoading, tryHideFullScreenLoading } from "../../config/serviceLoading";
import { BaseImageUrl } from "../../http/http";
import { useStore } from "../../store";

export const AboutUsManager: React.FC = () => {
    const { aboutUsStore } = useStore();
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(''))
    const [outputHTML, setOutPutHTML] = useState('')
    const handleEditorChange = (e:any) => {
      setEditorState(e)
      setOutPutHTML(e.toHTML())
    }

    useEffect(()=> {
      getList();
      return;
    }, [])

    const getList = ()=> {
      const params = {
          username: aboutUsStore.username
      }
      getManagerAboutUsInfo(params).then((res:any)=> {
        if(res.data.length > 0) {
          setEditorState(BraftEditor.createEditorState(res.data[0].content));
          setOutPutHTML(res.data[0].content);
          aboutUsStore.seIsSubmit(true);
          aboutUsStore.setDataSource(res.data);
        }
      })
    }

    const excludeControls:any = ['emoji', 'code']

    const myUploadFn = (param:any) => {
      showFullScreenLoading()
      const params = new FormData();
      params.append("file", param.file);
      params.append("watermark", '0');
      params.append("type", '6');
      uploadImages(params)
          .then((res:any) => {
              tryHideFullScreenLoading()
              if (Number(res.code) === 200) {
                message.success("上传成功");
                console.log(`${BaseImageUrl}${res.data}`)
                param.success({
                  url: `${BaseImageUrl}${res.data}`,
                  meta: {
                    title: param.file.name,
                    alt: param.file.name
                  }
                })
              } else {
                  message.error("图片上传失败");
              }
          }).catch(() => {
          message.error("图片上传失败");
          tryHideFullScreenLoading()
      })
    }

    const submit = ()=> {
      if (outputHTML === '') {
        message.error("请输入内容");
        return;
      }
      showFullScreenLoading();
      aboutUsStore.isSubmit ? editor() : save();
    }
    // 添加
    const save = ()=> {
      const formData = new FormData();
      let userInfo:any = localStorage.getItem('userInfo');
      userInfo = userInfo ? JSON.parse(userInfo) : {};
      const userid:any = userInfo?.id;
      formData.append('userid', userid?.toString());
      formData.append('content', outputHTML);
      addAboutUsInfo(formData).then((res:any) => {
          if (Number(res.code) === 200) {
            message.success("提交成功");
          } else {
            tryHideFullScreenLoading();
            message.error("提交失败");
          }
        }).catch(() => {
        message.error("提交失败");
        tryHideFullScreenLoading()
      })
    }
    // 编辑
    const editor = ()=> {
      const formData = new FormData();
      let userInfo:any = localStorage.getItem('userInfo');
      userInfo = userInfo ? JSON.parse(userInfo) : {};
      const userid:any = userInfo?.id;
      formData.append('userid', userid?.toString());
      formData.append('id', aboutUsStore.dataSource[0].id.toString());
      formData.append('content', outputHTML);
      editAboutUsInfo(formData).then((res:any) => {
          if (Number(res.code) === 200) {
            message.success("提交成功");
          } else {
            tryHideFullScreenLoading();
            message.error("提交失败");
          }
        }).catch(() => {
        message.error("提交失败");
        tryHideFullScreenLoading()
      })
    }
    return (
        <Layout style={{display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3"}}>
                <TitleSpan>关于我们</TitleSpan>
            </Header>
            <Content style={{flex: 1, overflow: 'hidden'}}>
                <Wrapper>
                    <BraftEditor
                        className={"editor-wrapper"}
                        excludeControls={ excludeControls }
                        value={ editorState }
                        onChange={ handleEditorChange }
                        media={{ uploadFn: myUploadFn, 
                                  accepts: { image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg'},
                                  externals: { image: true, video: false, audio: false, embed: false }  }}
                        placeholder="请输入内容"
                    />
                    <Button onClick={submit} type={"primary"} size={"large"} style={{margin: "20px auto"}}>提交</Button>
                </Wrapper>
            </Content>
        </Layout>
    );
}
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;
    flex: 1;

    .editor-wrapper {
      margin: 15px 15px 15px 15px;
      border-radius: 4px;
      border: 1px solid #EAEDF7;
      background: white;
    }
  }
`;

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;